<template>
  <portlet
      :icon="'fal fa-user-clock'"
      :title="'Poules'"
      :actionsBlock="false"
  >

    <template slot="portletBody">
      <datatables
          :tableClass="'existing-user-pools'"
          :rows="getGroupedPools"
          :columns="getColumns()"
          tableID="pools-overview-dt"
          routerLinkClass="dt-router-link"
          :tableInitOptions="tableInitOptions"
      ></datatables>
    </template>
  </portlet>
</template>


<script>
import {mapGetters} from "vuex";
import {currentCustomerName} from "@/utils/poolCustomerName";

export default {
  props: ["customer"],
  components: {},
  data() {
    return {
      tableInitOptions: {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
          searchPlaceholder: 'Zoeken...',
          sProcessing: 'Bezig...',
          sLengthMenu: '_MENU_',
          sZeroRecords: 'Geen resultaten gevonden',
          sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
          sInfoEmpty: 'Geen resultaten om weer te geven',
          sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
          sInfoPostFix: '',
          sSearch: '',
          sEmptyTable: 'Geen resultaten aanwezig in de tabel',
          sInfoThousands: '.',
          sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
          oPaginate: {
            sFirst: 'Eerste',
            sLast: 'Laatste',
            sNext: 'Volgende',
            sPrevious: 'Vorige'
          },
          oAria: {
            sSortAscending: ': activeer om kolom oplopend te sorteren',
            sSortDescending: ': activeer om kolom aflopend te sorteren'
          }
        },
        drawCallback() {
          const table = this;
          // Pagination
          var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
          pagination.toggle(this.api().page.info().pages > 1);


          function formatSubTable(data) {

            // `d` is the original data object for the row
            let table = `
              <table class="pools-child-table">
                <thead>
                    <th>Gebruikers</th>
                </thead>
                <tbody>`;
            data.pools.forEach(pool => {

              table += `
                        <tr>
                            <td>
                            <a   href="/candidates/${pool.candidateId}"  class="dt-router-link"   data-to="/candidates/${pool.candidateId}">
                                ${pool.candidate ? pool.candidate.firstName : ' deleted AVG'} ${pool.candidate ? pool.candidate.lastName : '??'}
                             </a>
                            </td>
                        </tr>`
            });

            table += `
                </tbody>
              </table>`
            return table;
          }


          // Child row display toggle
          $('#pools-overview-dt tbody').off('click', 'td.details-control');
          $('#pools-overview-dt tbody').on('click', 'td.details-control', function () {
            var tr = $(this).closest('tr');
            var row = table.api().row(tr);
            if (row.child.isShown()) {
              // This row is already open - close it
              row.child.hide();
              tr.removeClass('shown');
            } else {
              // Open this row
              row.child(formatSubTable(row.data())).show();
              tr.addClass('shown');
            }
          });
        }
      }
    };
  },
  methods: {
    getColumns() {
      let self = this;
      return [
        {
          className: 'details-control',
          orderable: false,
          data: null,
          defaultContent: '',
        },
        {
          width: '100%', orderable: false,
          data: 'customerName', name: 'Bedrijf', visible: true, searchable: true, responsivePriority: 1,
        },
        {
          // an invisible column with candidate names: so we can use the search input
          width: '100%', orderable: false,
          data: null, name: '', visible: false, searchable: true, responsivePriority: 1,
          render(data) {
            return _.map(data.pools, pool => {
              return `  <a     class="dt-router-link"   data-to="/candidates/${pool.candidateId}">
                ${pool.candidate ? pool.candidate.firstName : '?'} ${pool.candidate ? pool.candidate.lastName : '??'}
              </a>`

            })
          }
        },
      ]
    },

  },
  watch: {},
  computed: {
    ...mapGetters('pools', ['getPools']),
    ...mapGetters('candidates', ['getCandidate']),
    ...mapGetters('customers', ['getCustomer']),
    getGroupedPools() {
      const self = this
      // Filter out archived pools
      // Then add the candidate data to the active pool
      // Then group by customer id

      const groupedPools = _.groupBy(
          _.map(
              _.filter(this.getPools, {'archived': false}),
              activePool => {
                const candidateOfPool = self.getCandidate(activePool.candidateId);
                if (candidateOfPool) {
                  // Check if candidate's first name does not contain 'XXXX'
                  if (candidateOfPool.firstName && candidateOfPool.firstName.length && candidateOfPool.firstName.toLowerCase().indexOf('xxxx') < 0 || candidateOfPool.lastName.length && candidateOfPool.lastName.toLowerCase().indexOf('xxxx')) {
                    activePool.candidate = candidateOfPool;
                    return activePool;
                  }
                }
              }
          ).filter(activePool => activePool !== undefined), // Remove undefined entries
          'customerId'
      );

      return _.map(Object.keys(groupedPools), groupedPoolId => {
        return {
          customerId: groupedPoolId,
          pools: groupedPools[groupedPoolId],
          customerName: `${currentCustomerName(_.first(groupedPools[groupedPoolId]), this.getCustomer)} <b>(${_.size(groupedPools[groupedPoolId])})</b>`
        }
      })
    }
  },
};
</script>
<style lang="scss">
.pools-child-table {
  width: -webkit-fill-available;
  margin-left: 5%;
  border: 1px solid gray;
  background-color: #eeeeee;
}

.pools-child-table tbody tr:last-child td {
  border-bottom: 1px solid gray !important;
}

.pools-child-table tbody tr td, .pools-child-table thead th, #pools-overview-dt tbody tr td, #pools-overview-dt thead th {
  text-align: left !important;
}


td.details-control {
  background: url('../../assets/open_icon.png') no-repeat center center;
  cursor: pointer;
}

tr.shown td.details-control {
  background: url('../../assets/close_icon.png') no-repeat center center;
}
</style>